import { useCookies } from 'react-cookie';
import { CookieSetOptions } from 'universal-cookie';
import { StorageRecord } from '../../clientStorage/types';
import useClientStorage from '../../clientStorage/hooks/useClientStorage';
import { cookiesEnabled } from '../../../common/helpers/environment';

export type SetStatus = (newStatus: number, ttl?: number) => void;

export const getCookieExpiration = (ttl: number) => new Date(Date.now() + ttl);

const truthyOptions = ['true', '1'];
const falsyOptions = ['false', '0'];

const getFlagStatus = (storedValue: StorageRecord | undefined) => {
    if (typeof storedValue === 'string') {
        if (truthyOptions.includes(storedValue)) {
            return true;
        }

        if (falsyOptions.includes(storedValue)) {
            return false;
        }
    }

    return !!storedValue;
};

const usePersistedFlag = (flagKey: string, cookieOnly?: boolean): [boolean, SetStatus, boolean] => {
    const [cookies, setCookie] = useCookies([flagKey]);
    const clientStorage = useClientStorage();
    let flagStatus = false;
    let valueInStorage: StorageRecord | undefined;

    const valueInCookies = (cookies && cookies[flagKey]) || undefined;

    if (!cookieOnly) {
        valueInStorage = (clientStorage && clientStorage.getItem(flagKey)) || undefined;
    }

    const isSetInCookies = valueInCookies !== undefined;
    const isSetInStorage = valueInStorage !== undefined;

    if (isSetInCookies) {
        flagStatus = getFlagStatus(valueInCookies);
    } else if (!cookieOnly && isSetInStorage) {
        flagStatus = getFlagStatus(valueInStorage);
    }

    const setFlagStatus: SetStatus = (value, ttl) => {
        if (cookiesEnabled) {
            const cookieData: CookieSetOptions = {
                path: '/',
            };

            if (ttl) {
                cookieData.expires = getCookieExpiration(ttl);
            }

            setCookie(flagKey, value, cookieData);

            if (!cookieOnly && clientStorage) {
                clientStorage.setItem(flagKey, value, ttl);
            }
        }
    };

    return [flagStatus, setFlagStatus, cookiesEnabled];
};

export default usePersistedFlag;
